import {createRouter, createWebHashHistory} from 'vue-router'
import NProgress from 'nprogress'
import storage from 'store'
import {mainStore} from '@/store'
import {constantRoutes} from "@/config/router-config";
import {ACCESS_TOKEN} from '@/store/mutation-types'
import {notification} from "ant-design-vue";

const allowList = ['login', 'register', 'registerResult']
const loginRoutePath = '/user/login'
const defaultRoutePath = '/vip/list'

const router = createRouter({
    history: createWebHashHistory(),
    routes: constantRoutes,
});

// 定义一个resetRouter 方法，在退出登录后或token过期后 需要重新登录时，调用即可
function resetRouter() {
    const newRouter = createRouter({
        history: createWebHashHistory(),
        routes: constantRoutes,
    });
    router.matcher = newRouter.matcher;
}

router.beforeEach((to, from, next) => {
    // console.log("<#> router start to check, from:%o, to:%o", from, to);
    NProgress.start();
    const store = mainStore();
    store.count++;
    if (storage.get(ACCESS_TOKEN)) {
        if (to.path === loginRoutePath) {
            next({path: defaultRoutePath})
            NProgress.done()
        } else {
            if (store.roles.length === 0) {
                store.userGetInfo().then(res => {
                    const roles = res.data && res.data.userProfile;
                    store.generateRoutes({roles}).then(() => {
                        resetRouter();
                        store.addRouters.forEach(r => {
                            router.addRoute(r);
                        });
                        // 请求带有 redirect 重定向时，登录自动重定向到该地址
                        const redirect = decodeURIComponent(from.query.redirect || to.path)
                        if (to.path === redirect) {
                            // set the replace: true so the navigation will not leave a history record
                            next({...to, replace: true})
                        } else {
                            // 跳转到目的路由
                            next({path: redirect})
                        }
                    });
                }).catch(() => {
                    notification.error({
                        message: '错误',
                        description: '请求用户信息失败，请重试'
                    })
                    // 失败时，获取用户信息失败时，调用登出，来清空历史保留信息
                    store.userLogout().then(() => {
                        next({path: loginRoutePath, query: {redirect: to.fullPath}})
                    })
                });
            } else {
                next();
            }
        }
    } else {
        if (allowList.includes(to.name)) {
            // 在免登录名单，直接进入
            console.log("<-> in router white list, can go to directly.");
            next();
        } else {
            console.log("<-> no token, redirect to login.");
            next({path: loginRoutePath, query: {redirect: to.fullPath}});
            NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
        }
    }
})

router.afterEach(() => {
    NProgress.done(); // finish progress bar
})

export default router;